import LotteryGGLItem from "./LotteryGGLItem";
import LotteryManager, {LotteryItemEntity} from "./LotteryManager";
import O1HD from "../../../../engines/gameEngine";
import userService from "../../../../engines/services/userService";

const {ccclass, property} = cc._decorator;

/**
 *
 */
@ccclass
export default class LotteryGGLPrefab extends cc.Component {

    @property( { type:cc.Prefab , displayName:"刮刮乐Item" } )
    lotteryGGLItemPrefab : cc.Prefab = null;
    @property( { type:cc.Node , displayName:"内容节点" } )
    contentNode : cc.Node = null;
    @property({type:cc.Node,displayName:"返回按钮"})
    btnBack : cc.Node = null;

    private mApplyCount : number = 1;
    private hasOpenCount : number = 0;//已经开奖个数
    private lotteryManager : LotteryManager = new LotteryManager();
    private lotteryItemArray : LotteryItemEntity[] = [];
    private lotteryFlagArray : boolean[] = [];

    //是否开奖
    hasOpenPrize : boolean = false;


    onLoad () {}

    start () {

    }

    bindData( gglCount : number){
        this.mApplyCount = gglCount;
        this.refreshLotteryData();
    }

    /**
     * 刷新彩票数据
     */
    refreshLotteryData(){
        this.hasOpenPrize = false;
        this.lotteryFlagArray = [];
        this.contentNode.removeAllChildren();
        this.lotteryItemArray = this.lotteryManager.getLotteryResult( this.mApplyCount );
        for ( let i = 0 ; i < this.lotteryItemArray.length ; i ++ ) {
            let lotteryGGLItemNode = cc.instantiate( this.lotteryGGLItemPrefab );
            let randomFlag : boolean = false;
            if (this.lotteryItemArray[i].defineStr ) {

            }
            switch ( this.lotteryItemArray[i].defineStr ) {
                case "1":
                    if ( Math.random() > 0.6 ) {
                        randomFlag = true;
                    }
                    break;
                case "2":
                    if ( Math.random() > 0.8 ) {
                        randomFlag = true;
                    }
                    break;
                case "5":
                    if ( Math.random() > 0.8 ) {
                        randomFlag = true;
                    }
                    break;
                case "999":
                    let randomNum = Math.floor( Math.random() * 10000 );
                    if ( randomNum > 9998) {
                        randomFlag = true;
                    }
                    break;
                default:
                    if ( Math.random() > 0.5 ) {
                        randomFlag = true;
                    }
                    break;
            }

            this.lotteryFlagArray.push( randomFlag );
            lotteryGGLItemNode.getComponent(LotteryGGLItem).bindData( this, this.lotteryItemArray[i] , randomFlag );
            this.contentNode.addChild( lotteryGGLItemNode );
        }
    }

    /**
     * 开奖
     */
    openPrize( lotteryItemEntity : LotteryItemEntity , flag : boolean ,node:cc.Node){
        // if ( this.hasOpenCount++ == this.mApplyCount - 1 ) {
        //     this.hasOpenPrize = true;
        //     //显示返回
        //     this.btnBack.active = true;
        // }

        if( Number( lotteryItemEntity.defineStr) == 0 ){
            return;
        }

        if ( flag ) {
            if ( lotteryItemEntity.type == 1 ){
                //物品奖励
                let userUnlockZodiac = userService.mZodiacData;
                if ( !userUnlockZodiac ) {
                    userService.mZodiacData = `${lotteryItemEntity.defineStr}`;
                    // O1HD.getServices().localStorageSrv.setStorage( userService.GET_ZODIAC_KEY , `${lotteryItemEntity.defineStr}`);
                }else{
                    let tempZodiacArray = userUnlockZodiac.split( ",");
                    if ( !tempZodiacArray.includes( lotteryItemEntity.defineStr) ) {
                        userUnlockZodiac += `,${lotteryItemEntity.defineStr}`;
                        userService.mZodiacData = userUnlockZodiac;
                        // O1HD.getServices().localStorageSrv.setStorage( userService.GET_ZODIAC_KEY , userUnlockZodiac );
                    }
                }
                O1HD.emit("AmbryItem.activeZodiac" , lotteryItemEntity.defineStr );
            }else if( lotteryItemEntity.type == 2 ){
                //钱币奖励
                O1HD.getServices().userSrv.setCoins( Number( lotteryItemEntity.defineStr) , true ,node);
            }
        }

        // for ( let i = 0 ; i < this.lotteryItemArray.length ; i ++ ) {
        //     if ( this.lotteryFlagArray[i] ){
        //         if ( this.lotteryItemArray[i].type == 1 ){
        //             //物品奖励
        //             let userUnlockZodiac = O1HD.getServices().localStorageSrv.getStorage( userService.GET_ZODIAC_KEY );
        //             if ( !userUnlockZodiac ) {
        //                 O1HD.getServices().localStorageSrv.setStorage( userService.GET_ZODIAC_KEY , `${this.lotteryItemArray[i].defineStr}`);
        //             }else{
        //                 let tempZodiacArray = userUnlockZodiac.split( ",");
        //                 if ( !tempZodiacArray.includes( this.lotteryItemArray[i].defineStr) ) {
        //                     userUnlockZodiac += `,${this.lotteryItemArray[i].defineStr}`;
        //                     O1HD.getServices().localStorageSrv.setStorage( userService.GET_ZODIAC_KEY , userUnlockZodiac );
        //                 }
        //             }
        //             O1HD.emit("AmbryItem.activeZodiac" , this.lotteryItemArray[i].defineStr );
        //         }else if( this.lotteryItemArray[i].type == 2 ){
        //             //钱币奖励
        //             O1HD.getServices().userSrv.setCoins( Number( this.lotteryItemArray[i].defineStr) , true );
        //         }
        //     }
        // }
    }




    /**
     * 退出
     */
    onBtnExit(){
        // if ( this.hasOpenPrize == false ) {
        //     return;
        // }
        this.node.removeFromParent();
        this.node.destroy();
    }



}
